import React from 'react'

import { CSSObject } from '@emotion/react'
import styled from '@emotion/styled'
import {
  Box,
  Space,
  Text,
  Link,
  Color,
  Heading3,
  AlignItems,
  DisplayPosition,
  JustifyContent,
  FontFamily,
  Display,
  TextAlign,
  useTheme,
  BoxProps,
} from '@gousto-internal/citrus-react'

import SeedsDesktopImg from './assets/seeds-desktop.png'
import SeedsMobileImg from './assets/seeds-mobile.png'

const LeftSeedsArea = (props: BoxProps) => {
  const { theme } = useTheme()

  const Component = styled(Box)(() => ({
    backgroundPosition: 'bottom left',
    backgroundRepeat: 'repeat-x',
    transform: 'rotate(180deg)',
    ...(theme.responsiveStyle(
      [`url(${SeedsMobileImg})`, `url(${SeedsDesktopImg})`],
      ['backgroundImage'],
    ) as CSSObject),
  }))

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} />
}

const RightSeedsArea = (props: BoxProps) => {
  const { theme } = useTheme()

  const Component = styled(Box)(() => ({
    backgroundPosition: 'bottom left',
    backgroundRepeat: 'repeat-x',
    ...(theme.responsiveStyle(
      [`url(${SeedsMobileImg})`, `url(${SeedsDesktopImg})`],
      ['backgroundImage'],
    ) as CSSObject),
  }))

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} />
}

const TrustPilot = () => {
  const { theme } = useTheme()

  return (
    <Box
      position={DisplayPosition.Relative}
      display={Display.Flex}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.Center}
      width="100%"
      height="100%"
      maxHeight="296px"
      minHeight={['240px', '144px']}
      bg={Color.NeutralGrey_50}
      data-testid="TrustPilot"
    >
      <LeftSeedsArea
        position={DisplayPosition.Absolute}
        height="4rem"
        width={['100%', '7.75rem']}
        minHeight={[null, '9rem']}
        top="0"
        left={[null, '0']}
      />
      <Box paddingV={[20, 0]} display={Display.Block}>
        <Box paddingH={8} paddingV={0.5}>
          <Heading3 size={[3, 4]} fontFamily={FontFamily.SemiBold} textAlign={TextAlign.Center}>
            Over
            <Text display={Display.Inline} color={Color.Primary_600} fontFamily={FontFamily.Bold}>
              {' '}
              1 million meals{' '}
            </Text>
            cooked and loved
          </Heading3>
        </Box>
        <Space size={4} direction="vertical" />
        <Box
          width="100%"
          height={['3rem', '1.25rem']}
          className="trustpilot-widget"
          data-locale="en-GB"
          data-template-id="5419b6ffb0d04a076446a9af"
          data-businessunit-id="512cda6e000064000522fb6a"
          data-style-width="100%"
          data-theme="light"
          data-font-family="Montserrat"
          data-text-color={theme.color(Color.ColdGrey_800)}
          data-testid="TrustPilotContainer"
        >
          <Link href="https://uk.trustpilot.com/review/gousto.co.uk" target="_blank">
            Trustpilot
          </Link>
        </Box>
      </Box>
      <RightSeedsArea
        position={DisplayPosition.Absolute}
        height="4rem"
        width={['100%', '7.75rem']}
        minHeight={[null, '9rem']}
        bottom="0"
        right={[null, '0']}
      />
    </Box>
  )
}

export { TrustPilot }
